import { render, staticRenderFns } from "./DetalheTitulo.vue?vue&type=template&id=3d6232d8&scoped=true"
import script from "./DetalheTitulo.vue?vue&type=script&lang=js"
export * from "./DetalheTitulo.vue?vue&type=script&lang=js"
import style0 from "./DetalheTitulo.vue?vue&type=style&index=0&id=3d6232d8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6232d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d6232d8')) {
      api.createRecord('3d6232d8', component.options)
    } else {
      api.reload('3d6232d8', component.options)
    }
    module.hot.accept("./DetalheTitulo.vue?vue&type=template&id=3d6232d8&scoped=true", function () {
      api.rerender('3d6232d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DetalheTitulo.vue"
export default component.exports